import React, { PropTypes, PureComponent } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { subscribeToStore } from 'lib/observe';
import trackingObserver from 'lib/observe/trackingObserver';
import { getI18nInclude } from 'lib/format';
import appSelector from 'common/selectors/appSelector';
import { RenderTemplateTypes } from 'enums';
import analyticsStub from '../../../server/templates/dotComAnalyticsStub';
import appConfig from '../../../config';

const { shellVersion, secureCdnHost } = appConfig;
const BASE_HREF = `${secureCdnHost}/redesign/${shellVersion}`;

class BasicShell extends PureComponent {
    componentDidMount() {
        const { store } = this.context;
        this.unsubscribeFromStore = subscribeToStore(store, [
            trackingObserver
        ]);
    }

    componentWillUnmount() {
        if (this.unsubscribeFromStore) {
            this.unsubscribeFromStore();
        }
    }

    render() {
        const { app: { device, isMobile } } = this.props;
        return (
            <div>
                <Helmet
                    script={[{
                        src: `${BASE_HREF}/js/espn-head.js`
                    }, {
                        innerHTML: `
                            var espn = espn || {};
                            espn.build = '${shellVersion}';
                            var espn_ui = window.espn_ui || {};
                            espn_ui.deviceType = "${device}";
                            espn_ui.device = {
                                isMobile: ${isMobile}
                            };
                            espn.track = espn.track || {};
                            espn.track.data = ${JSON.stringify(analyticsStub)};
                        `
                    }, {
                        src: getI18nInclude()
                    }]}
                />
                {React.Children.only(this.props.children)}
                <script src={`${BASE_HREF}/js/espn-critical.js`} />
                <script src={`${BASE_HREF}/js/espn-analytics.js`} />
            </div>
        );
    }
}

BasicShell.propTypes = {
    app: PropTypes.object,
    children: PropTypes.node
};

BasicShell.contextTypes = {
    store: PropTypes.object
};

BasicShell.renderTemplate = RenderTemplateTypes.BASIC;

const mapStateToProps = (state) => ({
    app: appSelector(state)
});

export default connect(mapStateToProps)(BasicShell);



// WEBPACK FOOTER //
// ./app/webapp/subShell/BasicShell.js